// extracted by mini-css-extract-plugin
export default {"ProductWrapper":"product-module_ProductWrapper_P7QHL","ProductHeading":"product-module_ProductHeading_HcXxv","ProductContent":"product-module_ProductContent_AstIR"};